<main role="main" id="content" class="pre-loader">
  <section>
    <p>
    <a href="/">Click here to return to the learning portal</a>
    </p>
  </section>

</main>
